// extracted by mini-css-extract-plugin
module.exports = {"gold":"UserTasks_gold__3HGjY","silver":"UserTasks_silver__1pI-2","bronze":"UserTasks_bronze__3Y2bu","custom_input_td":"UserTasks_custom_input_td__2hLT8"};